import { create } from 'zustand';
import type { WalletOut } from '@/api/wallet';

interface WalletState {
  wallet: WalletOut | null;
  setWallet: (wallet: WalletOut | null) => void;
}

export const useWalletStore = create<WalletState>((set) => ({
  wallet: null,
  setWallet: (wallet) => set({ wallet })
}));
